import React from "react";
import Measure from "react-measure";
import VisibilitySensor from "react-visibility-sensor";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { TabSelectComponent, TabSelectControlComponent, TabSelectHighlightComponent, TabSelectContentComponent, TabSelectOptionsComponent, TabSelectOptionComponent, } from "./components";
import { withTheme } from "styled-components";
const autobind = require("class-autobind").default;
const visibilityProps = {
    partialVisibility: true,
    offset: {
        left: -400,
        right: -400,
    },
    resizeThrottle: 250,
};
class TabSelectClass extends React.Component {
    constructor(props) {
        super(props);
        // EVENTS
        this.onContentResize = (contentRect) => {
            const { bounds } = contentRect;
            if (bounds && this && this.setState) {
                this.setState({ containerWidth: bounds.width });
            }
        };
        autobind(this);
        this.state = {
            tabWidths: [],
            totalTabsWidth: 0,
            containerWidth: 0,
            scrollPosition: 0,
            overrideScrollPosition: 0,
        };
        this.content_id = `${props.id}-tab-select-content`;
        this.content_el = null;
        this.last_scroll_value = 0;
    }
    // LIFECYCLE
    componentDidMount() {
        if (typeof window !== "undefined") {
            this.content_el = document.getElementById(this.content_id);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            const initialScrollPosition = this.calculateScrollPosition();
            const scrollPosition = this.sanitizeScrollValue(initialScrollPosition);
            this.setState({ scrollPosition });
            this.last_scroll_value = scrollPosition;
        }
    }
    // ACTIONS
    scrollSideways(direction) {
        const scrollPosition = this.sanitizeScrollValue(this.state.scrollPosition + (direction === -1 ? -250 : 250));
        this.setState({ scrollPosition });
        this.last_scroll_value = scrollPosition;
    }
    // CALCULATIONS
    calculateHighlightWidth() {
        const { tabWidths } = this.state;
        return tabWidths[this.getSelectedIndex()];
    }
    calculateHighlightStartPosition() {
        const { tabWidths } = this.state;
        const activeKey = this.getSelectedIndex();
        return tabWidths.reduce((a, v, i) => {
            if (i < (activeKey)) {
                return a + v;
            }
            return a;
        }, 0);
    }
    calculateScrollPosition() {
        const { containerWidth } = this.state;
        const highlightStartPosition = this.calculateHighlightStartPosition();
        const bufferModifier = containerWidth > 600 ? 400 : 250;
        const bufferValue = Math.max((containerWidth - bufferModifier), 0);
        return Math.max((highlightStartPosition - bufferValue), 0);
    }
    sanitizeScrollValue(val) {
        // DONT LET IT GO BELOW 0 OR PAST TEH MAX CONTENT WIDTH
        if (val < -5)
            return 0;
        const { totalTabsWidth, containerWidth } = this.state;
        if (totalTabsWidth <= containerWidth) {
            // IF TOTAL TABS LESS THAN CONTAINER SIZE, NO SCROLL
            return 0;
        }
        else {
            // TOTAL TABS GREATER THAN CONTAINER, THERE IS A SCROLL
            const maxScroll = (totalTabsWidth - containerWidth);
            // IF THE SCROLL VALUE IS GREATER THAN THE LENGTH OF THE CONTENT ACCOUNTING FOR SCREEN SIZE
            if (val > maxScroll)
                return maxScroll;
            return val;
        }
    }
    getSelectedIndex() {
        const { value, values } = this.props;
        return values.findIndex((v) => v.value === value);
    }
    onOptionResize(contentRect, i) {
        const { tabWidths } = this.state;
        const { bounds } = contentRect;
        if (bounds) {
            const { width } = bounds;
            const tw = [...tabWidths];
            tw[i] = width;
            const totalTabsWidth = tw.reduce((a, val) => a + val, 0);
            this.setState({ tabWidths: tw, totalTabsWidth: totalTabsWidth });
            if (this.props.onWidthChange) {
                this.props.onWidthChange({ tabWidths: tw, totalTabsWidth: totalTabsWidth });
            }
        }
    }
    onOptionSelect(v) {
        this.props.onChange(v);
    }
    // PARTS
    leftScrollControl() {
        const background = this.props.background || this.props.theme.box.background;
        const { scrollPosition } = this.state;
        return (React.createElement(TabSelectControlComponent, { side: "left", background: background, hide: scrollPosition <= 0, onClick: () => this.scrollSideways(-1) },
            React.createElement(FaChevronLeft, null)));
    }
    rightScrollControl() {
        const background = this.props.background || this.props.theme.box.background;
        const { totalTabsWidth, containerWidth, scrollPosition } = this.state;
        const maxScroll = (totalTabsWidth - containerWidth);
        return (React.createElement(TabSelectControlComponent, { side: "right", background: background, hide: scrollPosition >= maxScroll, onClick: () => this.scrollSideways(1) },
            React.createElement(FaChevronRight, null)));
    }
    highlight() {
        const width = this.calculateHighlightWidth();
        const startPosition = this.calculateHighlightStartPosition();
        return React.createElement(TabSelectHighlightComponent, { startPosition: startPosition, width: width });
    }
    options() {
        const { values } = this.props;
        return (React.createElement(TabSelectOptionsComponent, null, values.map((v, i) => {
            return (React.createElement(Measure, { key: i, bounds: true, onResize: (contentRect) => this.onOptionResize(contentRect, i) }, ({ measureRef }) => (React.createElement(VisibilitySensor, Object.assign({ onChange: () => { } }, visibilityProps), ({ isVisible }) => (React.createElement("div", { ref: measureRef },
                React.createElement(TabSelectOptionComponent, { hidden: !isVisible, onClick: () => this.onOptionSelect(v) }, v.label)))))));
        })));
    }
    render() {
        const background = this.props.background || this.props.theme.box.background;
        const { style, className, noControls, hasBorder } = this.props;
        const { noScroll } = this.props;
        const { scrollPosition } = this.state;
        const position = -(noScroll ? 0 : scrollPosition);
        return (React.createElement(TabSelectComponent, { id: this.props.id, style: style, className: className, hasBorder: hasBorder, background: background },
            !noControls && this.leftScrollControl(),
            React.createElement(Measure, { bounds: true, onResize: this.onContentResize }, ({ measureRef }) => (React.createElement("div", { ref: measureRef },
                React.createElement(TabSelectContentComponent, { id: this.content_id, position: position },
                    this.options(),
                    this.highlight())))),
            !noControls && this.rightScrollControl()));
    }
}
export const TabSelect = withTheme((props) => React.createElement(TabSelectClass, Object.assign({}, props)));
//# sourceMappingURL=index.js.map